import React from "react";
import ReactDOM from "react-dom/client";
import "./theme.css";
import "./styles.css";
import App from "./App";
import "./guest-gallery-premium.css";
import { HomePage, UnifiedLoginPage } from "./PublicExperience";
import { InquiryPage } from "./InquiryPage";
import { getPublicSurface } from "./public-routes";
import { readPendingQrContext } from "./qr-context";
import "./premium.css";

// Preserve valid tab-scoped QR continuation for legacy root links that were
// already stripped to '/' by an earlier application version.
let pendingGuestQr = false;
try {
  pendingGuestQr = Boolean(readPendingQrContext());
} catch {
  // Storage-disabled browsers can still enter through the QR URL.
}
const surface = getPublicSurface(window.location, { pendingGuestQr });
const Page = surface === "home" ? HomePage : surface === "login" ? UnifiedLoginPage : surface === "inquiry" ? InquiryPage : App;
ReactDOM.createRoot(document.getElementById("root")).render(<React.StrictMode><Page /></React.StrictMode>);
